export const LOADING_PHRASES = [
  "Priming the pump...",
  "Deciphering beta...",
  "Taping up our flappers...",
  "Warming up the shoe rubber...",
  "Mentally rehearsing the crux...",
  "Searching for non-existent jugs...",
  "Finding the optimal knee-bar...",
  "Channeling our inner mountain goat...",
  "Hiding snacks from the area dog...",
  "Digesting send fuel...",
  "Bargaining with gravity...",
  "Sandbagging the model...",
  "Believing in tiny footholds...",
] as const;

/**
 * Returns a random loading phrase from the list of climbing-related phrases
 * @param t - Optional translation function from react-i18next
 */
export const getRandomLoadingPhrase = (
  t?: (key: string, options?: { returnObjects?: boolean }) => string | string[]
): string => {
  if (t) {
    // Use translated phrases if translation function is provided
    const translatedPhrases = t("common.loadingPhrases", {
      returnObjects: true,
    }) as string[];
    if (Array.isArray(translatedPhrases) && translatedPhrases.length > 0) {
      const randomIndex = Math.floor(Math.random() * translatedPhrases.length);
      return translatedPhrases[randomIndex];
    }
  }

  // Fallback to default English phrases
  const randomIndex = Math.floor(Math.random() * LOADING_PHRASES.length);
  return LOADING_PHRASES[randomIndex];
};
